import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";

import { LeaveHistoryListState } from "@reducers/types/HRM/leave-history-list-state";

import { getLeaveHistoryListRequest } from "@actions/HRM/leave/leave-history-actions";
import { getLeaveHistoryListState } from "@selectors/HRM/leave/leave-history-selectors";

import { useAppSelector } from "@helpers/redux";

interface UseLeaveHistoryList {
  leaveHistoryListRequest: boolean;
  leaveHistoryListSuccess: boolean;
  leaveHistoryListFailed: boolean;
  leaveHistoryList: any;
  pagination: any;
  handleQuery: (key: string, value: number) => void;
}

export const useLeaveHistory = (
  employeeId: string | number
): UseLeaveHistoryList => {
  const dispatch = useDispatch();

  const [query, setQuery] = useState({
    page: 1,
    size: 10,
  });

  const handleQuery = (key: string, value: number) =>
    setQuery((prev) => ({
      ...prev,
      [key]: value,
    }));

  const getLeaveHistoryList = useAppSelector<LeaveHistoryListState>(
    getLeaveHistoryListState
  );

  const leaveHistoryListRequest = getLeaveHistoryList.request as boolean;
  const leaveHistoryListSuccess = getLeaveHistoryList.success as boolean;
  const leaveHistoryListFailed = getLeaveHistoryList.failed as boolean;
  const { data: leaveHistoryList, pagination } = getLeaveHistoryList.data || {};

  useEffect(() => {
    dispatch(getLeaveHistoryListRequest({ query, employeeId }));
  }, [dispatch, query]);

  return {
    leaveHistoryListRequest,
    leaveHistoryListSuccess,
    leaveHistoryListFailed,
    leaveHistoryList,
    handleQuery,
    pagination,
  };
};
